// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"4647088f","72":"dde4bf20","98":"4f5b8c3c","166":"84daa861","370":"f1feb6f5","495":"fa58dbba","512":"17cceea7","653":"1844d088","764":"14e7ff75","878":"74e08f44","965":"0caa152d"}[chunkId] + ".chunk.js";
};